import { Link } from "react-router-dom";
import { Loader2, BookOpen } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useContentIndex } from "@/lib/content/useContentIndex";

export function GitaHub() {
  const { index, loading, error } = useContentIndex();
  const gitas = index?.gitas ?? [];

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="w-8 h-8 animate-spin text-primary" />
      </div>
    );
  }

  return (
    <div className="min-h-screen py-24 px-4 noise" data-testid="gita-hub">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-8">
          <h1 className="font-heading text-3xl">Sacred Gītās</h1>
          <p className="text-sm text-muted-foreground mt-2">
            Verse-by-verse study with short, dharmic translations. Ask Āchārya AI to expand when ready.
          </p>
        </div>
        {error && <p className="text-center text-destructive text-sm mb-4">{error}</p>}
        <div className="grid gap-4">
          {gitas.map((g) => (
            <Card key={g.id} className="bg-white/90">
              <CardHeader className="pb-2">
                <CardTitle className="font-heading text-xl flex items-center gap-2">
                  <BookOpen className="w-5 h-5 text-primary" />
                  {g.title}
                </CardTitle>
                <p className="text-xs text-muted-foreground">{g.source}</p>
              </CardHeader>
              <CardContent className="flex justify-between items-center">
                <span className="text-sm text-muted-foreground">
                  {g.chapter_count_loaded ?? g.chapters?.length ?? g.chapter_count ?? 0}
                  {g.chapter_count_declared && g.chapter_count_declared !== (g.chapter_count_loaded ?? g.chapters?.length)
                    ? ` / ${g.chapter_count_declared}`
                    : ""}{" "}
                  chapters
                  {g.verse_count != null ? ` · ${g.verse_count} verses` : ""}
                </span>
                <Button size="sm" asChild>
                  <Link to={`/gitas/${g.id}`}>Study</Link>
                </Button>
              </CardContent>
            </Card>
          ))}
        </div>
        <div className="text-center mt-8">
          <Button variant="ghost" asChild>
            <Link to="/library">← Sacred Library</Link>
          </Button>
        </div>
      </div>
    </div>
  );
}
